export default __webpack_public_path__ + "static/media/Group625.9dcbf44a.png";